type ResponseError = {
  response?: {
    data?: {
      msg: string;
    };
  };
};

// Type guard for our 'ResponseError'
function isResponseError(error: unknown): error is ResponseError {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return false;
  }
  const { response } = error;
  return (
    typeof response === "object" &&
    response !== null &&
    "data" in response &&
    Boolean(response.data)
  );
}

export const getErrorMsg = (error: unknown) => {
  if (isResponseError(error)) return error.response?.data?.msg ?? null;
  if (error instanceof Error) return error.message;
  return null;
};
